import {
  ScheduleAssignmentStatus,
  ScheduleAutoAssignStatus
} from './dc-schedule.model';

export function deriveScheduleAssignmentStatus(
  rosterAssigned: number,
  rosterTotal: number
): ScheduleAssignmentStatus {
  const total = Math.max(rosterTotal, 0);
  const assigned = Math.min(Math.max(rosterAssigned, 0), total);

  if (total <= 0 || assigned <= 0) {
    return 'NOT ASSIGNED';
  }
  if (assigned >= total) {
    return 'ASSIGNED';
  }
  return 'PARTIAL';
}

export function deriveEffectiveScheduleAutoAssignStatus(
  storedAutoAssignStatus: string | null | undefined,
  assignmentStatus: ScheduleAssignmentStatus
): ScheduleAutoAssignStatus {
  const normalizedStatus = `${storedAutoAssignStatus ?? ''}`
    .trim()
    .toUpperCase();
  if (!normalizedStatus) {
    return 'NOT RUN';
  }
  if (normalizedStatus === 'SUCCESS' && assignmentStatus !== 'ASSIGNED') {
    return 'FAILED';
  }
  if (normalizedStatus === 'SUCCESS' || normalizedStatus === 'FAILED') {
    return normalizedStatus;
  }
  return 'NOT RUN';
}
